

import React from 'react';
import './Career.css';

function Career() {
  return (
    <section className="career" id="career">
      <h2>Join Our Team</h2>
      <p>Shape your future with Alpha Vomega — where ideas become innovation.</p>

      <div className="job-listings">
        <div className="job-card">
          <h3>Frontend Developer</h3>
          <p>Work with React, modern CSS, and build stunning UIs for global clients.</p>
          <a href="mailto:hr@alphavomega.com?subject=Frontend%20Developer%20Application" className="apply-btn">Apply Now</a>
        </div>

        <div className="job-card">
          <h3>Backend Developer</h3>
          <p>Develop robust APIs and backend services using Node.js, Java, or Python.</p>
          <a href="mailto:hr@alphavomega.com?subject=Backend%20Developer%20Application" className="apply-btn">Apply Now</a>
        </div>

        <div className="job-card">
          <h3>UI/UX Designer</h3>
          <p>Design user-friendly interfaces and collaborate with product & dev teams.</p>
          <a href="mailto:hr@alphavomega.com?subject=UI%2FUX%20Designer%20Application" className="apply-btn">Apply Now</a>
        </div>

        <div className="job-card">
          <h3>Business Analyst</h3>
          <p>Work with stakeholders to define requirements and drive business impact.</p>
          <a href="mailto:hr@alphavomega.com?subject=Business%20Analyst%20Application" className="apply-btn">Apply Now</a>
        </div>
      </div>
    </section>
  );
}

export default Career;
